export default __webpack_public_path__ + "static/media/underconstruction.52c6b3bc.png";